import React from "react";
import {
  Box,
  Heading,
  OrderedList,
  ListItem,
  Text,
  UnorderedList,
  Link,
  chakra,
} from "@chakra-ui/react";
import { Trans, useTranslation } from "next-i18next";
import checkIfFullFridge from "@/utils/fullFridge";
import { useTranslation as useTranslationi18n } from "next-i18next";
import CustomHead from "@/components/common/CustomHead";

const TermsConditions = (): React.ReactElement => {
  const { t } = useTranslation();
  const { i18n } = useTranslationi18n();

  return (
    <>
      <CustomHead title={t("termsConditions.title")}/>
      <Box
        p={{ base: "30px 15px", sm: "50px", xl: "100px" }}
        textAlign="justify"
      >
        <Heading
          size="lg"
          variant="simple"
          fontSize={{ base: "23px", sm: "35px" }}
          textAlign="center"
        >
          {t("termsConditions.title")}
        </Heading>
        <Text textAlign="center" fontWeight="bold">
          {checkIfFullFridge()
            ? "www.fullfridge.app"
            : "www.garazowewyprzedaze.pl"}
        </Text>
        <chakra.small display="block" textAlign="center">
          {t("termsConditions.lastUpdate")}: 06.02.2025
        </chakra.small>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          I. {t("termsConditions.article1Title")}
        </Heading>
        <Text my={3}>
          {checkIfFullFridge() ? (
            <Trans
              i18nKey="termsConditions.article1Text1FF"
              components={{
                b: <chakra.b></chakra.b>,
              }}
            ></Trans>
          ) : (
            <Trans
              i18nKey="termsConditions.article1Text1"
              components={{
                b: <chakra.b></chakra.b>,
              }}
            ></Trans>
          )}
        </Text>
        <Text my={3}>{t("termsConditions.article1Text2")}</Text>
        <UnorderedList>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article1Text2Item1FF")
              : t("termsConditions.article1Text2Item1")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article1Text2Item2FF")
              : t("termsConditions.article1Text2Item2")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article1Text2Item3FF")
              : t("termsConditions.article1Text2Item3")}
          </ListItem>
          {checkIfFullFridge() && (
            <ListItem>{t("termsConditions.article1Text2Item4FF")}</ListItem>
          )}
        </UnorderedList>
        <Text my={3}>{t("termsConditions.article1Text3")}</Text>
        <Text my={3}>{t("termsConditions.article1Text4")}</Text>
        <Text my={3}>
          {checkIfFullFridge()
            ? t("termsConditions.article1Text5FF")
            : t("termsConditions.article1Text5")}
        </Text>
        <Text my={3}>{t("termsConditions.article1Text6")}</Text>
        <Text my={3}>{t("termsConditions.article1Text7")}</Text>
        <Text my={3}>
          {checkIfFullFridge()
            ? t("termsConditions.article1Text8FF")
            : t("termsConditions.article1Text8")}
        </Text>
        <Text my={3}>{t("termsConditions.article1Text9")}</Text>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          II. {t("termsConditions.article2Title")}
        </Heading>
        <OrderedList>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph1Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph1")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph2Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph2")}
          </ListItem>
          <ListItem>
            <b>
              {checkIfFullFridge()
                ? t("termsConditions.article2Paragraph3TitleFF")
                : t("termsConditions.article2Paragraph3Title")}
            </b>{" "}
            –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph3FF")
              : t("termsConditions.article2Paragraph3")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph4Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph4FF")
              : t("termsConditions.article2Paragraph4")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph5Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph5")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph6Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph6")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph7Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph7")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph8Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph8FF")
              : t("termsConditions.article2Paragraph8")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph9Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph9")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph10Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph10")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph11Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph11FF")
              : t("termsConditions.article2Paragraph11")}
          </ListItem>
          <ListItem>
            <b>
              {checkIfFullFridge()
                ? t("termsConditions.article2Paragraph12TitleFF")
                : t("termsConditions.article2Paragraph12Title")}
            </b>{" "}
            –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph12FF")
              : t("termsConditions.article2Paragraph12")}
          </ListItem>
          <ListItem>
            <b>
              {checkIfFullFridge()
                ? t("termsConditions.article2Paragraph13TitleFF")
                : t("termsConditions.article2Paragraph13Title")}
            </b>{" "}
            –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph13FF")
              : t("termsConditions.article2Paragraph13")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph14Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph14FF")
              : t("termsConditions.article2Paragraph14")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph15Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph15")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph16Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph16")}
          </ListItem>
          <ListItem>
            <b>
              {checkIfFullFridge()
                ? t("termsConditions.article2Paragraph17TitleFF")
                : t("termsConditions.article2Paragraph17Title")}
            </b>{" "}
            –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph17FF")
              : t("termsConditions.article2Paragraph17")}
          </ListItem>
          <ListItem>
            <b>
              {checkIfFullFridge()
                ? t("termsConditions.article2Paragraph18TitleFF")
                : t("termsConditions.article2Paragraph18Title")}
            </b>{" "}
            –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph18FF")
              : t("termsConditions.article2Paragraph18")}
          </ListItem>
          {!checkIfFullFridge() && (
            <ListItem>
              <b>{t("termsConditions.article2Paragraph19Title")}</b> –{" "}
              {t("termsConditions.article2Paragraph19")}
            </ListItem>
          )}
          <ListItem>
            <b>{t("termsConditions.article2Paragraph20Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph20FF")
              : t("termsConditions.article2Paragraph20")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph21Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph21FF")
              : t("termsConditions.article2Paragraph21")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph22Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph22")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph23Title")}</b> –{" "}
            {checkIfFullFridge()
              ? t("termsConditions.article2Paragraph23FF")
              : t("termsConditions.article2Paragraph23")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph24Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph24")}
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article2Paragraph25Title")}</b> –{" "}
            {t("termsConditions.article2Paragraph25")}
          </ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          III. {t("termsConditions.article3Title")}
        </Heading>
        <OrderedList>
          <ListItem>
            <b>{t("termsConditions.article3Paragraph1")}</b>
            <OrderedList listStyleType="lower-alpha">
              <ListItem>
                {t("termsConditions.article3Paragraph1Item1")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article3Paragraph1Item2FF")
                  : t("termsConditions.article3Paragraph1Item2")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph1Item3")}
              </ListItem>
            </OrderedList>
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article3Paragraph2")}</b>
            <OrderedList listStyleType="lower-alpha">
              <ListItem>
                {t("termsConditions.article3Paragraph2Item1")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article3Paragraph2Item2FF")
                  : t("termsConditions.article3Paragraph2Item2")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph2Item3")}
                <UnorderedList>
                  <ListItem>
                    {t("termsConditions.article3Paragraph2Item3Subitem1")}
                  </ListItem>
                  <ListItem>
                    {checkIfFullFridge()
                      ? t("termsConditions.article3Paragraph2Item3Subitem2FF")
                      : t("termsConditions.article3Paragraph2Item3Subitem2")}
                  </ListItem>
                </UnorderedList>
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph2Item4")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph2Item5")}
                <UnorderedList>
                  <ListItem>
                    {t("termsConditions.article3Paragraph2Item5Subitem1")}
                  </ListItem>
                </UnorderedList>
                <b>{t("termsConditions.article3Paragraph2Item5Text1")}</b>
                <UnorderedList>
                  <ListItem>
                    {checkIfFullFridge()
                      ? t("termsConditions.article3Paragraph2Item5Subitem2FF")
                      : t("termsConditions.article3Paragraph2Item5Subitem2")}
                  </ListItem>
                </UnorderedList>
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph2Item6")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph2Item7")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph2Item8")}
              </ListItem>
              {!checkIfFullFridge() && (
                <ListItem>
                  {t("termsConditions.article3Paragraph2Item9")}
                </ListItem>
              )}
            </OrderedList>
          </ListItem>
          <ListItem>
            <b>{t("termsConditions.article3Paragraph3")}</b>
            <OrderedList listStyleType="lower-alpha">
              <ListItem>
                {t("termsConditions.article3Paragraph3Item1")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph3Item2")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph3Item3")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article3Paragraph3Item4")}
              </ListItem>
            </OrderedList>
          </ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          IV. {t("termsConditions.article4Title")}
        </Heading>
        <OrderedList>
          <ListItem>
            <b>{t("termsConditions.article4Paragraph1")}</b>
            <OrderedList listStyleType="lower-alpha">
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article4Paragraph1Item1FF")
                  : t("termsConditions.article4Paragraph1Item1")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article4Paragraph1Item2")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article4Paragraph1Item3")}
                <UnorderedList>
                  <ListItem>
                    {checkIfFullFridge()
                      ? t("termsConditions.article4Paragraph1Item3Subitem1FF")
                      : t("termsConditions.article4Paragraph1Item3Subitem1")}
                  </ListItem>
                  <ListItem>
                    {checkIfFullFridge()
                      ? t("termsConditions.article4Paragraph1Item3Subitem2FF")
                      : t("termsConditions.article4Paragraph1Item3Subitem2")}
                  </ListItem>
                  <ListItem>
                    {checkIfFullFridge()
                      ? t("termsConditions.article4Paragraph1Item3Subitem3FF")
                      : t("termsConditions.article4Paragraph1Item3Subitem3")}
                  </ListItem>
                </UnorderedList>
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article4Paragraph1Item4FF")
                  : t("termsConditions.article4Paragraph1Item4")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article4Paragraph1Item5FF")
                  : t("termsConditions.article4Paragraph1Item5")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article4Paragraph1Item6FF")
                  : t("termsConditions.article4Paragraph1Item6")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article4Paragraph1Item7FF")
                  : t("termsConditions.article4Paragraph1Item7")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article4Paragraph1Item8FF")
                  : t("termsConditions.article4Paragraph1Item8")}
              </ListItem>
            </OrderedList>
          </ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          V. {t("termsConditions.article5Title")}
        </Heading>
        <OrderedList listStyleType="lower-alpha">
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article5Paragraph1FF")
              : t("termsConditions.article5Paragraph1")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article5Paragraph2FF")
              : t("termsConditions.article5Paragraph2")}
          </ListItem>
          <ListItem>{t("termsConditions.article5Paragraph3")}</ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          VI. {t("termsConditions.article6Title")}
        </Heading>
        <OrderedList>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article6Paragraph1FF")
              : t("termsConditions.article6Paragraph1")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article6Paragraph2FF")
              : t("termsConditions.article6Paragraph2")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article6Paragraph3FF")
              : t("termsConditions.article6Paragraph3")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article6Paragraph4FF")
              : t("termsConditions.article6Paragraph4")}
          </ListItem>
          {!checkIfFullFridge() && (
            <ListItem>{t("termsConditions.article6Paragraph5")}</ListItem>
          )}
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article6Paragraph6FF")
              : t("termsConditions.article6Paragraph6")}
          </ListItem>
          {checkIfFullFridge() && (
            <ListItem>{t("termsConditions.article6Paragraph7FF")}</ListItem>
          )}
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          VII. {t("termsConditions.article7Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("termsConditions.article7Paragraph1")}</ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article7Paragraph2FF")
              : t("termsConditions.article7Paragraph2")}
          </ListItem>
          <ListItem>{t("termsConditions.article7Paragraph3")}</ListItem>
          {!checkIfFullFridge() && (
            <ListItem>{t("termsConditions.article7Paragraph4")}</ListItem>
          )}
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          VIII. {t("termsConditions.article8Title")}
        </Heading>
        <Text my={3}>{t("termsConditions.article8Text1")}</Text>
        <OrderedList>
          <ListItem>
            {t("termsConditions.article8Paragraph1")}
            <OrderedList listStyleType="lower-alpha">
              <ListItem>
                {t("termsConditions.article8Paragraph1Subitem1")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph1Subitem2")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph1Subitem3")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph1Subitem4")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article8Paragraph1Subitem5FF")
                  : t("termsConditions.article8Paragraph1Subitem5")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph1Subitem6")}
              </ListItem>
            </OrderedList>
          </ListItem>
          <ListItem>
            {t("termsConditions.article8Paragraph2")}
            <OrderedList listStyleType="lower-alpha">
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem1")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem2")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem3")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem4")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article8Paragraph2Subitem5FF")
                  : t("termsConditions.article8Paragraph2Subitem5")}
              </ListItem>
              <ListItem>
                {checkIfFullFridge()
                  ? t("termsConditions.article8Paragraph2Subitem6FF")
                  : t("termsConditions.article8Paragraph2Subitem6")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem7")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem8")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem9")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem10")}
              </ListItem>
              <ListItem>
                {t("termsConditions.article8Paragraph2Subitem11")}
              </ListItem>
            </OrderedList>
          </ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          IX. {t("termsConditions.article9Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("termsConditions.article9Paragraph1")}</ListItem>
          <ListItem>{t("termsConditions.article9Paragraph2")}</ListItem>
          <ListItem>{t("termsConditions.article9Paragraph3")}</ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article9Paragraph4FF")
              : t("termsConditions.article9Paragraph4")}
          </ListItem>
          <ListItem>{t("termsConditions.article9Paragraph5")}</ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          X. {t("termsConditions.article10Title")}
        </Heading>
        <Text my={3}>{t("termsConditions.article10Text1")}</Text>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          XI. {t("termsConditions.article11Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("termsConditions.article11Paragraph1")}</ListItem>
          <ListItem>{t("termsConditions.article11Paragraph2")}</ListItem>
          <ListItem>{t("termsConditions.article11Paragraph3")}</ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article11Paragraph4FF")
              : t("termsConditions.article11Paragraph4")}
          </ListItem>
          <ListItem>
            {checkIfFullFridge()
              ? t("termsConditions.article11Paragraph5FF")
              : t("termsConditions.article11Paragraph5")}
          </ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          XII. {t("termsConditions.article12Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("termsConditions.article12Paragraph1")}</ListItem>
          <ListItem>{t("termsConditions.article12Paragraph2")}</ListItem>
          <ListItem>{t("termsConditions.article12Paragraph3")}</ListItem>
          <ListItem>{t("termsConditions.article12Paragraph4")}</ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          XIII. {t("termsConditions.article13Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("termsConditions.article13Paragraph1")}</ListItem>
          <ListItem>{t("termsConditions.article13Paragraph2")}</ListItem>
          <ListItem>{t("termsConditions.article13Paragraph3")}</ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          XIV. {t("termsConditions.article14Title")}
        </Heading>
        <OrderedList>
          <ListItem>{t("termsConditions.article14Paragraph1")}</ListItem>
          <ListItem>
            <Trans i18nKey="termsConditions.article14Paragraph2">
              W razie potrzeby, Użytkownik może również przedstawić skargi
              dotyczące działania Serwisu w celu rozstrzygnięcia sporu za
              pośrednictwem platformy udostępnionej przez Komisję Europejską pod{" "}
              <Link
                href={
                  i18n?.language == "pl"
                    ? "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=PL"
                    : "https://ec.europa.eu/consumers/odr/main/index.cfm?event=main.home2.show&lng=EN"
                }
                target="_blank"
              >
                adresem
              </Link>
              .
            </Trans>
          </ListItem>
          <ListItem>{t("termsConditions.article14Paragraph3")}</ListItem>
          <ListItem>{t("termsConditions.article14Paragraph4")}</ListItem>
        </OrderedList>
        <Heading size="md" fontSize={{ base: "18px", sm: "20px" }}>
          XV. {t("termsConditions.article15Title")}
        </Heading>
        <Text my={3}>
          <Trans
            i18nKey="termsConditions.article15Text1"
            components={{
              b: <chakra.b></chakra.b>,
            }}
          ></Trans>
        </Text>
        <Text my={3}>
          {t("termsConditions.article15Text2", {
            email: checkIfFullFridge()
              ? "office@fullfridge.app"
              : "kontakt@garazowewyprzedaze.pl",
          })}
        </Text>
        <Text my={3}>
          <Trans
            i18nKey="termsConditions.article15Text3"
            components={{
              b: <chakra.b></chakra.b>,
            }}
          ></Trans>
        </Text>
      </Box>
    </>
  );
};

export default TermsConditions;
